import { TabsProvider } from "./providers";
import { TabsItem } from "./tabs-item.component";
import { TabsContent } from "./tabs-content.component";
import { TabsNav } from "./tabs-nav.component";
import { TabsBody } from "./tabs-body.component";
import { TabsIcon } from "./tabs-icon.component";
import { TabsText } from "./tabs-text.component";

import type { AllHTMLAttributes, ReactNode } from "react";
import type { Optional } from "../../types";

import styles from "./tabs.module.css";

export type TabsProps = {
  children: ReactNode;
  value?: Optional<string>;
  onTabChange?: (name: string) => void;
} & AllHTMLAttributes<HTMLDivElement>;

function _Tabs({ children, ...props }: TabsProps) {
  return (
    <div {...props} className={styles.Container}>
      {children}
    </div>
  );
}

export function Tabs({ children, value, onTabChange, ...props }: TabsProps) {
  return (
    <TabsProvider value={value} onTabChange={onTabChange}>
      <_Tabs value={value} {...props}>
        {children}
      </_Tabs>
    </TabsProvider>
  );
}

export namespace Tabs {
  export const Content = TabsContent;
  export const Item = TabsItem;
  export const Body = TabsBody;
  export const Icon = TabsIcon;
  export const Text = TabsText;
  export const Nav = TabsNav;
}
